import { faPaperclip as AttachmentIcon } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { useAtom } from 'jotai';

import { ticketAtom } from '@/pages/Ticket';
import { axiosClient } from '@/services/BaseApi.service';

const TemplateTicketAttachments = () => {
  const [{ attachments: ticket_attachments, id: ticketId }] =
    useAtom(ticketAtom);

  const handleAttachmentClick = (ticket_id: number, file_key: string) => {
    const downloadAttachment = async () => {
      const response = await axiosClient.get(
        `/tickets/${ticket_id}/attachments/${file_key}`
      );
      return window.open(response.data.download_url, '_blank');
    };
    return downloadAttachment();
  };

  return (
    <>
      <Divider sx={{ borderWidth: '1px' }} />
      <Typography variant="h5">Attachments</Typography>
      <Stack spacing={0.5}>
        {ticket_attachments?.map((attachment) => (
          <Stack
            sx={{ alignItems: 'flex-start' }}
            key={attachment.key}
            spacing={2}
          >
            <Button
              onClick={() => handleAttachmentClick(ticketId, attachment.key)}
            >
              {attachment.file_name}
              <FontAwesomeIcon icon={AttachmentIcon} size="xs" />
            </Button>
          </Stack>
        ))}
      </Stack>
    </>
  );
};

export default TemplateTicketAttachments;
